export default __webpack_public_path__ + "./image/866674cd54f5b5ddc28d2f93088bf80d.png";